import React from "react";
import RadioField from "../../../common/components/FormFields/RadioField";
import { useForm, useFormContext } from "react-hook-form";
import { useEMRContext } from "./EMRContextGync";


export default function BloodGroup(props) {
  const { BloodGroupData } = useEMRContext()
  // const defaultValues = {
  //   bloodGroup:"A+"
  // };
  const {
    control,
    watch,
    register,
    handleSubmit,
    setValue,
    setError,
    formState: { errors },
  } = useFormContext({
    mode: "onChange",
    // defaultValues,

  });
  return (
    <div>
      <div className="bg-blue-50 rounded shadow my-2 px-2 py-1">
        <div className="flex">
          <p className="text-sm font-semibold  pl-2 py-2">
            Blood Group &nbsp; :
          </p>
          <div className="pl-3 pt-[5px]">
          
                <RadioField
                  control={control}
                  name="bloodGroup"
                  dataArray={BloodGroupData}
                />
            

          </div>
        </div>
      </div>
    </div>
  );
}
